function WhiteButton (props) {
    return (
        <div>
            <button className="my-4 w-64 bg-white p-2 rounded text-BrandOrange "><a className="block" href={props.link}>{props.text}</a> </button>
        </div>
    );
}

export default WhiteButton;